import React, { useState, useEffect } from 'react';

import QuickStats from './QuickStats';
import MoodTrendChart from './MoodTrendChart';
import CrisisSupport from '../resources/CrisisSupport';
import { storage } from '../../utils/storage';
import { MOOD_EMOJIS } from '../../utils/constants';

const Dashboard = () => {
  const [moodData, setMoodData] = useState([]);
  const [todayMood, setTodayMood] = useState(null);
  const [showQuickCheckin, setShowQuickCheckin] = useState(false);
  const [quickMood, setQuickMood] = useState(0);

  useEffect(() => {
    const saved = storage.get('moodData') || [];
    setMoodData(saved);
    
    const today = new Date().toDateString();
    const todayEntry = saved.find(m => new Date(m.date).toDateString() === today);
    setTodayMood(todayEntry);
  }, []);

  const handleQuickCheckin = () => {
    if (quickMood > 0) {
      const newEntry = {
        id: Date.now(),
        date: new Date().toISOString(),
        mood: quickMood,
        contexts: [],
        note: 'Quick check-in'
      };
      
      const updated = [...moodData, newEntry];
      setMoodData(updated);
      storage.set('moodData', updated);
      setTodayMood(newEntry);
      setShowQuickCheckin(false);
      setQuickMood(0);
    }
  };

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold mb-2">Welcome back!</h1>
        <p className="text-gray-600">Here's your mental wellness overview</p>
      </div>

      <QuickStats todayMood={todayMood} onQuickCheckin={() => setShowQuickCheckin(true)} />
      
      {moodData.length > 0 && <MoodTrendChart moodData={moodData} />}
      
      <CrisisSupport />

      {/* Quick Check-in Modal */}
      {showQuickCheckin && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl p-6 max-w-md w-full">
            <h3 className="text-xl font-semibold mb-4">How are you feeling?</h3>
            <div className="flex justify-around mb-6">
              {MOOD_EMOJIS.map((emoji, index) => (
                <button
                  key={index}
                  onClick={() => setQuickMood(index + 1)}
                  className={`text-3xl p-3 rounded-lg transition-all ${
                    quickMood === index + 1 
                      ? 'bg-blue-100 scale-110' 
                      : 'hover:bg-gray-100'
                  }`}
                >
                  {emoji}
                </button>
              ))}
            </div>
            <div className="flex space-x-3">
              <button
                onClick={handleQuickCheckin}
                disabled={!quickMood}
                className={`flex-1 py-2 rounded-lg font-medium ${
                  quickMood 
                    ? 'bg-blue-600 text-white hover:bg-blue-700' 
                    : 'bg-gray-300 text-gray-500 cursor-not-allowed'
                }`}
              >
                Save
              </button>
              <button
                onClick={() => {
                  setShowQuickCheckin(false);
                  setQuickMood(0);
                }}
                className="flex-1 py-2 rounded-lg border border-gray-300 hover:bg-gray-50"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Dashboard;